import { PillTabs } from './PillTabs'
import { Tab } from './PillTabs/Tab'
import { TabLabel } from './PillTabs/TabLabel'
import AssignmentItem from './AssignmentItem'
import { Box, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Loader } from 'packages/eid-ui'
import { defaultApplicationLogoImage, getFullImageUrl } from 'utils'
import { isNilOrEmpty, paginate } from 'packages/core'

const TabsContainer = styled(Box)({
    display: 'flex',
    width: '101% !important',
    marginBottom: '-0.3rem',
    marginLeft: '-0.1rem',
    zIndex: 999,
})

const ItemsSection = styled(Box)(({ theme }) => ({
    background: `${theme?.palette.common.white} !important`,
    width: '26rem !important',
    overflow: 'hidden',
    height: '37.6rem',
    overflowY: 'auto',
    padding: '0.5rem',
    '&::-webkit-scrollbar': {
        display: 'none',
    },
}))

const TabedLists = ({
    tabs,
    onSelectedTabChange,
    selectedTabValue,
    checkIfDisabled,
    isLoading = false,
    searchTerm,
    ...rest
}) => {
    const { t } = useTranslation()

    const selectedTab = tabs.find((t) => t.label === selectedTabValue)

    let items = selectedTab?.items || []
    let filteredItems = []
    if (!selectedTab?.isServerPaginated) {
        if (searchTerm) {
            filteredItems = items.filter((item) =>
                item.friendlyName
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase()),
            )
            items = paginate(filteredItems, selectedTab?.page, 5)
        } else {
            items = paginate(items, selectedTab?.page, 5)
        }
    }

    return (
        <Box display="flex" flex={'1'} margin="10px">
            <TabsContainer display="flex" flexDirection="column">
                <PillTabs
                    variant={'standard'}
                    value={selectedTab?.label || ''}
                    onChange={(_, tabValue) => {
                        if (tabValue) {
                            onSelectedTabChange(tabValue)
                        }
                    }}
                >
                    {tabs?.map((tab, i) => {
                        return (
                            <Tab
                                label={
                                    <TabLabel
                                        label={tab?.label}
                                        count={
                                            isLoading
                                                ? undefined
                                                : searchTerm &&
                                                  !selectedTab?.isServerPaginated
                                                ? filteredItems.length
                                                : tab?.total
                                        }
                                        countColor={tab?.countColor}
                                    />
                                }
                                value={tab?.label}
                                data-ai-explain={`Tab: ${tab?.label}`}
                            />
                        )
                    })}
                </PillTabs>

                {isLoading && (
                    <ItemsSection>
                        <Loader height="100%" />
                    </ItemsSection>
                )}

                {!isLoading && (
                    <ItemsSection>
                        {items.length < 1 ? (
                            <p>{t('NoDataFound')}</p>
                        ) : (
                            items.map((item) => (
                                <AssignmentItem
                                    key={item.id}
                                    item={{
                                        ...item,
                                        primaryText: item?.friendlyName,
                                        secondaryText: item?.description,
                                    }}
                                    imageThumbUrl={
                                        isNilOrEmpty(item?.icon)
                                            ? getFullImageUrl(
                                                  defaultApplicationLogoImage,
                                              )
                                            : getFullImageUrl(item?.icon)
                                    }
                                    isAlreadyMoved={checkIfDisabled(item)}
                                    showPlusIcon={selectedTab?.showPlusIcon}
                                    showCrossIcon={selectedTab?.showCrossIcon}
                                    {...rest}
                                />
                            ))
                        )}
                    </ItemsSection>
                )}
            </TabsContainer>
        </Box>
    )
}

export default TabedLists
